import React, {useState, useEffect} from 'react';
import {Button, Dimmer, Image, Popup} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {fileThumbnailType} from "../../constants";
import ImageViewerModal from "../ImageViewerModal";
import {arrayBufferToBase64} from "../../utils/genericUtils";
import {filesActions} from "../../behavior/files";
import {connect} from "react-redux";

export const FileThumbnail = ({file, fileList, download, downloadAsBA, setIsPreviewShown, isPreviewShown, selfDownloadedThumbnail, isSelfDownloadThumbnail, api}) => {
	const [active, setActive] = useState(false);
	const [thumbnailBase64, setThumbnailBase64] = useState(!!file.thumbnailBase64 ? `data:image/jpeg;base64,${file.thumbnailBase64}` : null);
	const isImageViewPossible = () => !!thumbnailBase64;

	useEffect(() => {
		if (!thumbnailBase64 && file?.fileType?.toLowerCase() == "image" && isSelfDownloadThumbnail && !selfDownloadedThumbnail)
			downloadAsBA(api, file.id, true);
	}, [file.id]);

	useEffect(() => {
		if (selfDownloadedThumbnail)
			setThumbnailBase64(arrayBufferToBase64(selfDownloadedThumbnail));
	}, [selfDownloadedThumbnail]);

    const getSrc = () => {
        let src;
        if (isImageViewPossible())
            src = thumbnailBase64;
        else if (Object.keys(fileThumbnailType).includes(file?.fileType?.toLowerCase()))
            src = fileThumbnailType[file?.fileType?.toLowerCase()];
        else
            src = fileThumbnailType.unknown;
        return src;
    };

    const content =
        <Dimmer active={active} verticalAlign='top'>
            <Button icon='download' compact size='mini' onClick={() => download(api, file.id, file.filePath, file.name)}/>
            {isImageViewPossible() &&
						<ImageViewerModal
							file={file}
							fileList={fileList}
							setIsPreviewShown={setIsPreviewShown}
							api={api}/>}
        </Dimmer>;

    return (<Popup
        wide="very"
        on={['hover', 'click']}
        basic
        position="top left"
        size='mini'
        content={file.name}
        open={active}
        trigger={
            <Dimmer.Dimmable
                dimmed={active}
                as={Image}
                className='fileThumbnail'
                style={{
                    height: '50px',
                    width: isImageViewPossible() ? '100px' : '50px',
                    backgroundImage: `url('${getSrc()}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
                onMouseEnter={() => !isPreviewShown && setActive(true)}
                onMouseLeave={() => setActive(false)}
                dimmer={{active, content}}/>
        }
    />);
};

const FileThumbnails = ({files, downloadAsBA, download, selfDownloadedThumbnails, isSelfDownloadThumbnail, api}) => {
    const [isPreviewShown, setIsPreviewShown] = useState(false);

    return files && files.length > 0 && files.map(file =>
        <FileThumbnail
            key={file.id}
            file={file}
            fileList={files}
            setIsPreviewShown={setIsPreviewShown}
            isPreviewShown={isPreviewShown}
						downloadAsBA={downloadAsBA}
						download={download}
						selfDownloadedThumbnail={selfDownloadedThumbnails[file.id]}
						isSelfDownloadThumbnail={isSelfDownloadThumbnail}
						api={api}
/>
    );
};

FileThumbnails.defaultProps = {
	selfDownloadedThumbnails: {},
	isSelfDownloadThumbnail: false
};

FileThumbnails.propTypes = {
    files: PropTypes.array.isRequired
};

const mapStateToProps = (state, ownProps) => ({
	selfDownloadedThumbnails: state.files.selfDownloadedThumbnails
});

const mapDispatchToProps = dispatch => ({
	download: (api, fileId) => dispatch(filesActions.download(api, fileId)),
	downloadAsBA: (api, fileId, isThumbnail) => dispatch(filesActions.downloadAsBA(api, fileId, isThumbnail)),
});


export default connect(mapStateToProps, mapDispatchToProps)(FileThumbnails);
